import { KeyValue } from '@/main/models/common';

export enum SystemApplicationTypes {
  GET_SYSTEM_APPLICATION = '@systemApplication/GET_SYSTEM_APPLICATION',
  SAVE_SYSTEM_APPLICATION = '@systemApplication/SAVE_SYSTEM_APPLICATION',
  RESET_REDUCER_SYSTEM_APPLICATION = '@systemApplication/RESET_REDUCER_SYSTEM_APPLICATION',
}

export interface SystemApplicationState {
  readonly systemApplication: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSystemApplication {
  type: typeof SystemApplicationTypes.GET_SYSTEM_APPLICATION;
}

export interface SaveSystemApplication {
  type: typeof SystemApplicationTypes.SAVE_SYSTEM_APPLICATION;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSystemApplication {
  type: typeof SystemApplicationTypes.RESET_REDUCER_SYSTEM_APPLICATION;
}

export type SystemApplicationActionTypes =
  | GetSystemApplication
  | SaveSystemApplication
  | ResetReducerSystemApplication;

